// Discount/Incentive core
export function discountIncentiveTypeCore() {
  const endpoint = '/discounts/fixedtypes';
  const detailId = 'discountTypeId';

  const getDetailId = (data = null) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      return data[0][detailId];
    }

    return data[detailId];
  };

  return {
    endpoint,
    detailId,
    getDetailId: getDetailId
  };
}

// Discount/Incentive filter
export function discountIncentiveTypeFilter() {
  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.discountTypeId,
        label: row.discountTypeDescription
      };
    });

    return rows;
  };

  return {
    getRows: getRows
  };
}
